import { CommonAlertService } from './../../services/common-alert.service';
import { filter } from 'rxjs/operators';
import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgForm, Form } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { N_MODULE } from '../../config/config'; 


@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss']
})
export class UserModalComponent implements OnInit {
  public rolesData: any;
  public editOb: any;
  public editData: any;
  public reportData: any;
  public filter: any;
  public total_count: any;
  public locationData: any;
  public successMsg: any;
  public resultData: any;
  public notificationData: any;
  public  newData: any;

  public formData: any  = {
    location_id : '',
    role_id : '',
    first_name : '',
    last_name : '',
    email : '',
    username : '',
    password : '',
    Sale_Order_Notification: '',
    Sale_Invoice_Notification: '',
    Sale_Reorder_Notification: '',
    Implants_Consumed_Notification: '',
    Implants_Rejected_Notification: '',
    Implants_Movement_Notification: ''
  };
  public editPermission = false;
  public formShow = 'add';
  constructor(public dialogRef: MatDialogRef<UserModalComponent>,
              public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    if (data) {
      this.editOb = data;
      this.formShow = this.editOb.type;
    }
  }

  ngOnInit() {

            // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.users.edit'] == 1) {
        this.editPermission = true;
      }
    }
    this.masterService.getData('/user_roles/get').subscribe(res => {
      // @ts-ignore
      this.rolesData = res.data;
    });
    this.masterService.getData('/locations/get').subscribe(res => {
      // @ts-ignore
      this.locationData = res.data;

    });
    this.masterService.getData('/user_roles/getreportlist').subscribe(res => {
      // @ts-ignore
      this.resultData = res.data.items;

     
    });





    if (this.editOb) {
      const id = this.editOb.id; 
      // tslint:disable-next-line:variable-name
      const enc_id = this.editOb.enc_Id;
      this.masterService.getRecordById(id, enc_id, '/users/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data;
         if (this.editData.userReport[N_MODULE.Sale_Order_Notification])
             this.formData.Sale_Order_Notification = true;
         if (this.editData.userReport[N_MODULE.Sale_Invoice_Notification])
             this.formData.Sale_Invoice_Notification = true;
         if (this.editData.userReport[N_MODULE.Implants_Movement_Notification])
             this.formData.Implants_Movement_Notification = true;
         if (this.editData.userReport[N_MODULE.Sale_Reorder_Notification])
             this.formData.Sale_Reorder_Notification = true;
         if (this.editData.userReport[N_MODULE.Implants_Consumed_Notification])
             this.formData.Implants_Consumed_Notification = true;
         if (this.editData.userReport[N_MODULE.Implants_Rejected_Notification])
             this.formData.Implants_Rejected_Notification = true;

      });
    }
  }

  submitForm(data) {
    if (this.editData) {
      const url = (this.formShow === 'edit') ? '/users/update' : '/users/update_password';
      // tslint:disable-next-line:variable-name no-shadowed-variable max-line-length
      const form_data = Object.assign(data, { id: this.editOb.id }, { enc_id: this.editOb.enc_id }, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, url).subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      }); 
    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data,  { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/users/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }


    this.close();
  }




  close() {
    this.dialogRef.close();
  }

}
